import React, { useState } from 'react';
import { Form } from 'react-simple-form-control';
import { useParams } from "react-router-dom";
import EmailBlacklistService from '../services/Email/EmailBlacklistService';

const Descadastrar = () => {

    const { hash } = useParams();
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        hash: {
            value: hash
        },
        tipoDescadastrar: {
            value: '',
            validation: {
                output: "tipoDescadastrarError",
                validators: [{
                    type: "required",
                    msg: "Campo obrigatório."
                }]
            }
        }
    });
    const [descadastrado, setDescadastrado] = useState(false);

    function handleSubmit(value, [valid]) {
        if (!valid) return;
        setLoading(true);
        EmailBlacklistService.add(value).then(
            () => {
                setDescadastrado(true);
                setLoading(false);
            }, error => {
                setLoading(false);
            });
    }

    return (
        <div className="container py-5">
            <div className="row">
                <div className="col-md-12">
                    <h3>Descadastrar.</h3>

                    {descadastrado ?
                        <>
                            <p>Descadastrado com sucesso.<br /></p>
                        </>
                        :
                        <>
                            <Form onSubmit={handleSubmit} formControl={form} onChangeForm={(form) => setForm(form)}>
                                <div className="form-group col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div className="row">
                                        <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 uninter-dados-contato-un">
                                            <label className="form-check-label" htmlFor="txtTipoDescadastrar">Descadastra de:</label>
                                            <p>
                                                <input type="radio" id="type1" value="1" name="tipoDescadastrar" />Apenas do assunto do e-mail.<br />
                                                <input type="radio" id="type2" value="2" name="tipoDescadastrar" />Todos e-mails.<br />
                                                <span id="tipoDescadastrarError"></span>
                                            </p>
                                        </div>
                                        <div className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 uninter-dados-contato-box">
                                            <input type="submit" className="btn uninter-btn-padrao" value="Salvar" />
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </>}
                </div>
            </div>
        </div>
    );
};

export default Descadastrar;